/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react';
import { gql, useQuery, useLazyQuery, useApolloClient ,useMutation } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import Header from '../components/Headers/Header';
import CustomLoader from '../components/Loader/CustomLoader';
import DataTable from 'react-data-table-component';
import { Icon } from '@iconify/react';
import {
  Container,
  Box,
  Button,
  useTheme,
  CircularProgress,
} from '@mui/material';
import { customStyles } from '../utils/tableCustomStyles';
import useGlobalStyles from '../utils/globalStyles';
import TableHeader from '../components/TableHeader';
import OutOfStockReportDetails from '../components/Reports/OutOfStockReportDetails';
import { getCSOutOfStockProductReports, getCSOutOfStockProductReport,generateOOSReport } from '../apollo';

const GET_OUT_OF_STOCK_REPORTS = gql`${getCSOutOfStockProductReports}`;
const GET_OUT_OF_STOCK_REPORT = gql`${getCSOutOfStockProductReport}`;
const GENERATE_OOS_REPORT = gql`${generateOOSReport}`;

const OutOfStockProductReport = (props) => {
  const { t } = props;
  const theme = useTheme();
  const globalClasses = useGlobalStyles();
  const client = useApolloClient();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedReport, setSelectedReport] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);

  const [generateOOSReport, { loading: generating }] = useMutation(GENERATE_OOS_REPORT, {
    onCompleted: () => refetch({ skip: (page - 1) * perPage, limit: perPage }),
    onError: (error) => {
      console.error('Error generating OOS report:', error);
      alert('Failed to generate report. Please try again.');
    },
  });


  const { loading, data, refetch } = useQuery(GET_OUT_OF_STOCK_REPORTS, {
    variables: { skip: (page - 1) * perPage, limit: perPage },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
  if (data && data.getCSOutOfStockProductReports) {
    setTableData(data.getCSOutOfStockProductReports.reports || []);
    setTotalRows(data.getCSOutOfStockProductReports.totalCount || 0);
  }
},

    onError: function (error) {
      var isForbiddenError =
        error &&
        error.graphQLErrors &&
        error.graphQLErrors.some(function (err) {
          return err.extensions.code === 'FORBIDDEN';
        });

      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  });

  const [fetchDetails] = useLazyQuery(GET_OUT_OF_STOCK_REPORT, {
    fetchPolicy: 'network-only',
    onCompleted: function (data) {
      if (data && data.getCSOutOfStockProductReport) {
        setSelectedReport(data.getCSOutOfStockProductReport);
        setOpenDetails(true);
      }
    },
  });

  useEffect(() => {
    refetch({ skip: (page - 1) * perPage, limit: perPage });
  }, [page, perPage]);

  const columns = [
    {
      name: 'Serial Number',
      cell: function (row, index) {
        return <>{(page - 1) * perPage + index + 1}</>;
      },
    },
    {
      name: 'Store Name',
      selector: function (row) {
        return row.storeName;
      },
      sortable: true,
    },
    {
      name: 'Total Out-of-Stock Items',
      cell: function (row) {
        return row.totalCount || 0;
      },
    },
    {
      name: 'Created At',
      cell: function (row) {
        return new Date(row.createdAt).toLocaleString();
      },
    },
    {
      name: t('Action'),
      cell: function (row) {
        return (
          <Button
            size="small"
            variant="contained"
            sx={{
              fontWeight: 'bold',
              backgroundColor: theme.palette.warning.dark,
              color: theme.palette.common.white,
              fontSize: '10px',
              '&:hover': {
                border: '1px solid #637BFE',
                color: theme.palette.warning.dark,
                backgroundColor: '#fff',
              },
            }}
            onClick={function () {
              fetchDetails({ variables: { id: row._id } });
            }}
          >
            {t('View Details')}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Header />
       <Container className={globalClasses.flex} fluid>
        {/* Box for the Refresh Button, aligned to the right above the table */}
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
          <Box sx={{ mb: 3 }}> {/* Added margin-bottom here for spacing */}
            <Button
              className={globalClasses.dashbordBtn}
              onClick={() => {
                generateOOSReport();
              }}
              disabled={loading || generating}
            >
              <Icon icon="ic:round-refresh" style={{ color: 'white', marginRight: 8 }} />
              {loading || generating ? 'Refreshing...' : t('REFRESH')} 
            </Button>
          </Box>
        </Box>
        <DataTable
          customStyles={customStyles}
          title={<TableHeader title="Out of Stock Report Summary" />}
          columns={columns}
          data={tableData}
          progressPending={loading}
          progressComponent={<CustomLoader />}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationDefaultPage={page}
          onChangeRowsPerPage={function (newPerPage) {
            setPerPage(newPerPage);
            setPage(1);
          }}
          onChangePage={function (newPage) {
            setPage(newPage);
          }}
        />
      </Container>

      <OutOfStockReportDetails
        open={openDetails}
        onClose={function () {
          setOpenDetails(false);
        }}
        report={selectedReport}
      />
    </>
  );
};

export default withTranslation()(OutOfStockProductReport);
